import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Vector from './assets/cek.png';
import Api from './Api';

function SSoft_Solutions_Question_Cards() {
  const [sectionItems, setSectionItems] = useState([]);

  const activeLang = useSelector((state) => state.content.activeLanguage);

  useEffect(() => {
    const fetchData = async () => {
      const api = new Api();
      const sectionResponse = await api.getSectionDetail({ language: activeLang });
      const sectionData = sectionResponse;

      setSectionItems(sectionData.data.results[0]);
    };

    fetchData();
  }, [activeLang]);

  let title, icon, questionContents;
  if (sectionItems) {
    const secWidgets = sectionItems.widgets;
  
    if (secWidgets) {
      secWidgets?.forEach((data, id) => {
        switch (id) {
          case 0:
            title = data?.widget_contents?.map((ctx) => ctx.content);
            break;
          case 1:
            icon = data?.widget_contents[0];
            break;
          case 2:
            questionContents = data?.widget_contents;
            break;
          default:
            break;
        }
      });
    }
  }
  
  return (
    <div className="section-container section-margin-x w-full h-full py-[50px] xs:py-[70px] sm:py-[120px]  space-y-[48px]">
      <div className="w-full h-full flex justify-center items-center text-center">
        <div className="max-w-[452px] h-full space-y-[15px]">
          <h1 className="h-full header-style-non-hero">{title && title[0]}</h1>
          <p className="text-[14px] tracking-[.42px] font-medium">
            {title && title[1]}
          </p>
        </div>
      </div>
      <div className="w-full h-full grid grid-cols-1 s:grid-cols-2 md:grid-cols-3 gap-[30px]">
        {questionContents &&
          questionContents.map((data) => (
            <div
              key={data.id}
              className="w-full h-full bg-[#FAF8F4] p-[30px] space-y-[25px] flex flex-col items-start self-stretch"
            >
              <img
                className="w-[25px] h-[25px]"
                src={icon.file_small}
                alt={icon.description}
              />
              <h2 className="font-bold text-[18px] leading-[130%]">
                {data.content}
              </h2>
            </div>
          ))}
      </div>
    </div>
  );
}

export default SSoft_Solutions_Question_Cards